import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Text, Link, Box, Structure, Section, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"bot/poluavtomaticheskiy-priyem-oplaty"} />
		<Helmet>
			<title>
				Полу-автоматический прием оплаты
			</title>
			<meta name={"description"} content={"Есть простой и дешевый вариант такого способа, который добавляется один раз и позволяет Вам использовать любое количество способов оплаты хоть фиатных платежей, хоть криптовалюты — «полуавтоматический способ оплаты»."} />
			<meta property={"og:title"} content={"Полу-автоматический прием оплаты"} />
			<meta property={"og:description"} content={"Есть простой и дешевый вариант такого способа, который добавляется один раз и позволяет Вам использовать любое количество способов оплаты хоть фиатных платежей, хоть криптовалюты — «полуавтоматический способ оплаты»."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
			padding="12px 0px 12px 0px"
		>
			<Override
				slot="Content"
				grid-template-columns="5fr 3fr"
				nout-grid-template-columns="3fr 3fr"
				lg-grid-template-columns="1fr 2fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
			>
				<Override slot="cell-0">
					<LinkBox href="https://www.ucoz.ru/bot/" pointer-events="none">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<LinkBox flex-direction="row" href="/en" display="none" sm-display="flex">
						<Text
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							English
						</Text>
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override
							slot="Button Text"
							nout-text-transform="uppercase"
							nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif"
							nout-letter-spacing="1px"
							sm-display="flex"
							sm-align-items="center"
							sm-justify-content="center"
						>
							меню
						</Override>
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="20px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="https://www.ucoz.ru/bot/"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Магазин в Телеграм
							</Link>
							<Link
								href="/bot/#easy"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Возможности
							</Link>
							<Link
								href="/bot/#top"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Преимущества
							</Link>
							<Link
								href="/bot/#price"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Цены
							</Link>
							<Link
								href="/bot/#example"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Примеры
							</Link>
							<Link
								href="/bot/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								sm-padding="5px 5px 5px 5px"
								sm-font="normal 700 14px/1.5 &quot;Montserrat&quot;, sans-serif"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
					sm-align-items="center"
				/>
				<Override slot="cell-1">
					<Box
						min-width="100px"
						min-height="100px"
						align-items="center"
						justify-content="center"
						display="flex"
					>
						<Text
							color="--grey"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							Ru
						</Text>
						<Link
							href="https://www.ucoz.com/bot/"
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".6"
							padding="5px 5px 5px 5px"
						>
							En
						</Link>
					</Box>
					<Link
						href="/bot/instrukciya/"
						color="--dark"
						text-decoration-line="initial"
						font="--menu"
						transition="--opacityOut"
						hover-opacity=".8"
						padding="5px 5px 5px 5px"
						pointer-events="auto"
						user-select="auto"
						cursor="pointer"
					>
						Инструкция
					</Link>
					<Components.ButtonBot />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Полуавтоматический прием оплаты
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Перевод средств по вашим реквизитам (номер телефона, адрес кошелька, номер карты)
			</Text>
			<Link
				href="https://t.me/Dolce_Bot"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				text-align="center"
			>
				Пример бота с оплатой на реквизиты
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				Оплата переводом для бот-магазина
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				По стандарту после оформления заказа мы пользователю отправляем его заказ с кнопкой оплатить если подключена онлайн оплата, если онлайн оплаты нет, можно отправлять свои реквизиты карты для перевода, пример:{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23:01:41.895Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytransfer.png?v=2024-11-22T23%3A01%3A41.895Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Чтобы добавить свои реквизиты в это сообщение, вам нужно зайти в раздел "Настройка уведомлений"
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23:03:22.054Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paymessage.png?v=2024-11-22T23%3A03%3A22.054Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Вам нужно пункта "Уведомлять при оформлении нового заказа" возле галочки TGShop нужно нажать на иконочку "Карандашика" и добавить свой текст с реквизитами
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23:20:51.905Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paytext.png?v=2024-11-22T23%3A20%3A51.905Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="4px 0px 0px 0px" font="italic 500 16px/160% --fontFamily-googleMontserrat" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--grey">
				Пример размещенного текста
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Наш код, который вы можете установить и для себя:
			</Text>
			<Components.ExampleCode>
				&lt;b&gt;$SHOP_NAME$ - Ваш заказ (№ $ORDER_ID$)&lt;/b&gt;
				<br />
				<br />
				$ADD_DATE$ $ADD_TIME$ вы оформили заказ
				<br />
				<br />
				$BODY$
				<br />
				<br />
				💰 Сумма: $ORDER_TOTAL$
				<br />
				<br />
				----------------------------------------------------------
				<br />
				<br />
				Если вам удобнее оплатить переводом, то наши реквизиты:
				<br />
				<br />
				💳 Карта МИР: &lt;code&gt;2204 1201 0770 4237&lt;/code&gt;
				<br />
				<br />
				&lt;i&gt;При оплате заказа укажите номер заказа (№ $ORDER_ID$) в комментариях&lt;/i&gt;
			</Components.ExampleCode>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				✅ Готово, вы же можете поставить свой текст и добавить кнопку чтобы сразу вам отправляли чеки об оплате.
Данный способ удобен тем у кого нет возможности на начале пути подключить онлайн оплату
			</Text>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Бот-магазин в Телеграм
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Если вы хотите, чтобы магазин сделали за вас, то вы можете воспользоваться нашей услугой бот-магазин под ключ
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});